import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    flat: "",
    dark: "",
    tile: "",
    "clipped-left": "",
    dense: "",
    color: "primary"
  }, {
    default: _withCtx(() => [
      (_ctx.viewName && 'home'.toLowerCase() !== _ctx.viewName.toLowerCase())
        ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
            key: 0,
            class: "text-body-1 text-capitalize ma-0 pl-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.viewName), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      (_ctx.user && _ctx.user.username !== 'anonymous')
        ? (_openBlock(), _createBlock(_component_v_menu, { key: 1 }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                variant: "text",
                size: "small",
                class: "text-lowercase"
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.user.username) + "   ", 1),
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-account", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, { density: "compact" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { onClick: _ctx.logout }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("Log out", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}